import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminEditChart = () => {
  const queryClient = useQueryClient();

  return apiClient.chart.editChart.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-charts-list'] });
      toast.success('Chart updated successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error updating chart!');
    },
  });
};
